// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.galleryplace_gSection__w\\+3Qr {
  background-color: #1c243b;
  margin: 5px;
  position: relative;
  border-radius: 5px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.galleryplace_gClosebtn__0tabR {
  position: relative;
  right: 20px;
  z-index: 2;
  margin: 3px;
}

.galleryplace_gClosebtn1__kHNYc {
  position: absolute;
  right: 80px;
}

.galleryplace_gClosebtn2__JRU7H {
  position: absolute;
  right: 67px;
}

.galleryplace_gClosebtnJust__lVu4e {
  justify-content: end;
  padding: 5px 13px;
}

.galleryplace_gImg__Vt2LB {
  padding: 2px;
}

.galleryplace_searchGallery__PoYKD {
  background-color: #ffffff !important;
}

.galleryplace_GsearchBtn__spk75 {
  position: absolute;
  top: 0px;
  margin: 3px;
  right: 0px;
}

.galleryplace_ResultNotFound__4qmYZ {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.galleryplace_ImgCon__fPO26 {
  padding: 10px;
  overflow: auto;
  margin-top: 10px;
  height: 70vh;
}

.galleryplace_ImgGSpinner__Z6rAO {
  display: flex;
  height: 65vh;
  justify-content: center;
  align-items: center;
}

.galleryplace_paginationBox__kpNNw {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  margin-top: 30px;
}

.galleryplace_LeftSec__qf\\+UL {
  transition: 0.3s ease;
}

.galleryplace_GPCloseContainer__Fbt4b {
  position: absolute;
  transition: 0.4s ease;
  right: -100vw;
  z-index: 2;
}

.galleryplace_GPOpenContainer__ghT6Z {
  right: 0%;
  position: relative;
  transition: 0.4s ease;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/styles/ItemsStyle/galleryplace.module.scss"],"names":[],"mappings":"AAMA;EACE,yBAAA;EAEA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;AANF;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AALF;;AAOA;EACE,kBAAA;EACA,WAAA;AAJF;;AAMA;EACE,kBAAA;EACA,WAAA;AAHF;;AAKA;EACE,oBAAA;EACA,iBAAA;AAFF;;AAIA;EACE,YAAA;AADF;;AAGA;EAGE,oCAAA;AAFF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AADF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AACF;;AACA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AAAA;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;AAGF;;AADA;EACI,qBAAA;AAIJ;;AAFA;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,UAAA;AAKJ;;AAFA;EACI,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AAKJ","sourcesContent":[".gClose {\n \n}\n.gOpen {\n \n}\n.gSection {\n  background-color: #1c243b;\n  // min-height: 100vh;\n  margin: 5px;\n  position: relative;\n  border-radius: 5px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.gClosebtn {\n  position: relative;\n  right: 20px;\n  z-index: 2;\n  margin: 3px;\n}\n.gClosebtn1 {\n  position: absolute;\n  right: 80px;\n}\n.gClosebtn2 {\n  position: absolute;\n  right: 67px;\n}\n.gClosebtnJust {\n  justify-content: end;\n  padding: 5px 13px;\n}\n.gImg {\n  padding: 2px;\n}\n.searchGallery {\n  // top: 0px;\n  // position: absolute;\n  background-color: #ffffff !important;\n}\n.GsearchBtn {\n  position: absolute;\n  top: 0px;\n  margin: 3px;\n  right: 0px;\n}\n.ResultNotFound{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.ImgCon {\n  padding: 10px;\n  overflow: auto;\n  margin-top: 10px;\n  height: 70vh;\n}\n.ImgGSpinner{\n  display: flex;\n  height: 65vh;\n  justify-content: center;\n  align-items: center;\n}\n.paginationBox{\n  display: flex;\n  justify-content: space-around;\n  padding: 10px;\n  margin-top: 30px;\n}\n.LeftSec{\n    transition: 0.3s ease;\n}\n.GPCloseContainer{\n    position: absolute;\n    transition: 0.4s ease;\n    right: -100vw;\n    z-index: 2;\n}\n\n.GPOpenContainer{\n    right: 0%;\n    position: relative;\n    transition: 0.4s ease;\n    z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gSection": `galleryplace_gSection__w+3Qr`,
	"gClosebtn": `galleryplace_gClosebtn__0tabR`,
	"gClosebtn1": `galleryplace_gClosebtn1__kHNYc`,
	"gClosebtn2": `galleryplace_gClosebtn2__JRU7H`,
	"gClosebtnJust": `galleryplace_gClosebtnJust__lVu4e`,
	"gImg": `galleryplace_gImg__Vt2LB`,
	"searchGallery": `galleryplace_searchGallery__PoYKD`,
	"GsearchBtn": `galleryplace_GsearchBtn__spk75`,
	"ResultNotFound": `galleryplace_ResultNotFound__4qmYZ`,
	"ImgCon": `galleryplace_ImgCon__fPO26`,
	"ImgGSpinner": `galleryplace_ImgGSpinner__Z6rAO`,
	"paginationBox": `galleryplace_paginationBox__kpNNw`,
	"LeftSec": `galleryplace_LeftSec__qf+UL`,
	"GPCloseContainer": `galleryplace_GPCloseContainer__Fbt4b`,
	"GPOpenContainer": `galleryplace_GPOpenContainer__ghT6Z`
};
export default ___CSS_LOADER_EXPORT___;
